import React, { Component } from "react";
import { CSSTransitionGroup } from "react-transition-group";
import PropTypes from "prop-types";
import "./CopyToClipboard.css";

class CopyToClipboard extends Component {
  render() {
    if (this.props.copyToClipboard) {
      this.textArea.select();
      document.execCommand("copy");
    }

    return (
      <div className="tooltip-container">
        <CSSTransitionGroup
          component="div"
          transitionName="tooltip-transition"
          transitionAppear={false}
          transitionAppearTimeout={0}
          transitionEnterTimeout={1}
          transitionLeaveTimeout={300}
        >
          {this.props.copyToClipboard ? (
            <div className="tooltip">
              hello@outro.co copied to clipboard!
              <div className="carrot-container">
                <div className="carrot" />
              </div>
            </div>
          ) : null}
        </CSSTransitionGroup>
        <textarea
          className="hiddenTextArea"
          cols="1"
          rows="1"
          defaultValue="hello@outro.co"
          ref={textarea => (this.textArea = textarea)}
        />
      </div>
    );
  }
}

CopyToClipboard.propTypes = {
  copyToClipboard: PropTypes.bool.isRequired,
};

export default CopyToClipboard;



// WEBPACK FOOTER //
// ./src/components/CopyToClipboard.js